import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ROUTES } from '../constants';
import { IOffreCritereResponse } from '../models/offre-critere.model';

@Injectable({
  providedIn: 'root'
})
export class OffreCritereService {

  constructor(
    private httpClient: HttpClient
  ) {}

  /**
   * Get all offreCriteres critere
   * @returns
   */
  getAll(): Observable<IOffreCritereResponse> {
    return this.httpClient.get<IOffreCritereResponse>(`${ROUTES.offreCritere.list}`);
  }

  /**
   * Get one offre critere
   * @returns
   */
  getOne(id: number): Observable<IOffreCritereResponse> {
    return this.httpClient.get<IOffreCritereResponse>(`${ROUTES.offreCritere.one}/${id}`);
  }

  /**
   * Get one offre critere
   * @returns
   */
  getByOffre(id: number): Observable<IOffreCritereResponse> {
    return this.httpClient.get<IOffreCritereResponse>(`${ROUTES.offreCritere.useOffreID}/${id}/${1}`);
  }
}
